// =============================================================
// ConnectionStatus  Phase 4
// Visual badge showing the status of a Google connection
// =============================================================

import React from 'react';

export type StatusType =
  | 'ACTIVE'
  | 'CONNECTED'
  | 'EXPIRED'
  | 'REVOKED'
  | 'ERROR'
  | 'DISCONNECTED'
  | 'NOT_CONNECTED';

interface Props {
  status: StatusType;
  label?: string;
}

export const ConnectionStatus: React.FC<Props> = ({ status, label }) => {
  const getBadgeConfig = () => {
    switch (status) {
      case 'ACTIVE':
      case 'CONNECTED':
        return {
          className: 'badge badge-green',
          text: label || 'Connected',
          dotColor: '#10b981',
        };
      case 'EXPIRED':
        return {
          className: 'badge badge-amber',
          text: label || 'Expired  Reconnect Required',
          dotColor: '#f59e0b',
        };
      case 'REVOKED':
        return {
          className: 'badge badge-rose',
          text: label || 'Revoked',
          dotColor: '#ef4444',
        };
      case 'ERROR':
        return {
          className: 'badge badge-rose',
          text: label || 'Error',
          dotColor: '#ef4444',
        };
      case 'DISCONNECTED':
      case 'NOT_CONNECTED':
      default:
        return {
          className: 'badge badge-gray',
          text: label || 'Not Connected',
          dotColor: '#6b7280',
        };
    }
  };

  const config = getBadgeConfig();

  return (
    <span
      className={`status-indicator-badge ${config.className}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: '6px',
        fontWeight: 600,
        fontSize: '0.8rem',
        padding: '3px 10px',
        borderRadius: '9999px',
      }}
    >
      <span
        style={{
          width: '7px',
          height: '7px',
          borderRadius: '50%',
          backgroundColor: config.dotColor,
          display: 'inline-block',
        }}
      />
      {config.text}
    </span>
  );
};
